import { combineReducers } from 'redux';

import {
    AUTH_SUCCESS,
    AUTH_SET_TOKEN,
    AUTH_LOGOUT,
    SET_REDIRECT_TO_REFERRER,
} from 'modules/auth/actions/authentication.action';

import { DEBTS_PARALIZED, DEBTS_STARTED_CHARGES } from 'modules/company/actions/company.action';
import { FINISHED_IMPORT, FINISHED_MANUAL_IMPORT, PROCESSED_SPREADSHEET } from 'modules/importer/actions/importer.action';

import { PRODUCT_LIST_CHANGED } from 'modules/product/actions/product.action';

const authToken = (state = null, action) => {
    switch (action.type) {
        case AUTH_SET_TOKEN:
            return action.payload;
        case AUTH_LOGOUT:
            return null;
        default:
            return state;
    }
};

const authUser = (state = null, action) => {
    switch (action.type) {
        case AUTH_SUCCESS:
            return action.payload;
        case FINISHED_IMPORT:
            return {
                ...state,
                completed_profile: true,
                has_debt: true,
            };
        case FINISHED_MANUAL_IMPORT:
            return {
                ...state,
                has_debt: true,
            };
        case PROCESSED_SPREADSHEET:
            return {
                ...state,
                has_debt: true,
            };
        case DEBTS_PARALIZED:
            return {
                ...state,
                has_paralized_debts: true,
            };
        case DEBTS_STARTED_CHARGES:
            return {
                ...state,
                has_paralized_debts: false,
            };
        case PRODUCT_LIST_CHANGED:
            if (action.payload && action.payload.items) {
                return {
                    ...state,
                    has_product_without_campaing: !!action.payload.items.filter(product => product.fk_campaign === null).length,
                };
            }
            return state;
        case AUTH_LOGOUT:
            return null;
        default:
            return state;
    }
};

const loggedOut = (state = false, action) => {
    switch (action.type) {
        case AUTH_LOGOUT:
            return action.payload;
        case AUTH_SUCCESS:
            return false;
        default:
            return state;
    }
};

const redirectToReferrer = (state = null, action) => {
    switch (action.type) {
        case SET_REDIRECT_TO_REFERRER:
            return action.payload;
        case AUTH_LOGOUT:
            return null;
        default:
            return state;
    }
};

export default combineReducers({
    authUser,
    authToken,
    redirectToReferrer,
    loggedOut,
});
